<template>
    <v-card class="main-content-card" flat id="proj-index-card">
        <v-toolbar flat>
            <v-toolbar-title>科研项目</v-toolbar-title>
            <span class="subheading ml-2">|</span>
            <v-tooltip top>
                <template v-slot:activator="{ on }">
                    <v-btn round small color="orange darken-1" class="white--text"
                           target="_blank"
                           :href="excelUrl">
                      <v-icon dark small>table_chart</v-icon>导出Excel
                    </v-btn>
                </template>
                <span>导出上限为2000条</span>
            </v-tooltip>

            <!--            <v-tooltip top>-->
            <!--                <template v-slot:activator="{ on }">-->
            <!--                    <v-btn color="primary" class="ml-3">TEST</v-btn>-->
            <!--                </template>-->
            <!--                <span>导出上限为2000条</span>-->
            <!--            </v-tooltip>-->
            <!--:disabled="!funcIds.includes('c_awar_submit')"-->

        </v-toolbar>

        <v-divider/>

        <!-- 检索功能区 -->
        <v-container fluid grid-list-md class="px-4" style="background-color: rgba(245, 245, 245, 0.6);">
            <v-layout row wrap>
                <v-flex d-flex xs10>
                    <v-layout row wrap>
                        <v-flex xs12 sm6>
                            <v-text-field
                                    label="项目名称"
                                    v-model="form.name"
                                    :clearable="true"
                                    hide-details/>
                        </v-flex>

                        <v-flex xs12 sm3>
                            <v-text-field
                                    label="委托单位"
                                    v-model="form.client"
                                    :clearable="true"
                                    hide-details/>
                        </v-flex>

                        <v-flex xs12 sm3>
                            <v-autocomplete
                                    item-text="name"
                                    item-value="dbid"
                                    :items="deptItems"
                                    v-model="form.deptId"
                                    label="归属部门"
                                    hide-details
                                    clearable
                                    :menu-props="{maxHeight:450}"/>
                        </v-flex>

                        <v-flex xs12 sm3>
                            <v-text-field
                                    label="项目负责人"
                                    v-model="form.leaderName"
                                    :clearable="true"
                                    hide-details/>
                        </v-flex>

                        <v-flex xs12 sm3>
                            <v-text-field
                                    label="项目组成员"
                                    v-model="form.member"
                                    :clearable="true"
                                    hide-details/>
                        </v-flex>

                        <v-flex xs12 sm3>
                            <v-menu
                                    ref="refEntryDateStart"
                                    :close-on-content-click="false"
                                    v-model="menuEntryDateStart"
                                    lazy
                                    transition="scale-transition"
                                    offset-y
                                    full-width
                                    max-width="290px">
                                <v-text-field
                                        slot="activator"
                                        v-model="form.entryDateStart"
                                        label="立项时间(起始)"
                                        :rules="rules.startDate"
                                        hint="格式YYYY-MM-DD, 如：2018-10-01"
                                        persistent-hint/>
                                <v-date-picker
                                        v-model="entryDateStart"
                                        locale="zh-cn"
                                        @change="nv => form.entryDateStart= nv"
                                />
                            </v-menu>
                        </v-flex>

                        <v-flex xs12 sm3>
                            <v-menu
                                    ref="refEntryDateEnd"
                                    :close-on-content-click="false"
                                    v-model="menuEntryDateEnd"
                                    lazy
                                    transition="scale-transition"
                                    offset-y
                                    full-width
                                    max-width="290px">
                                <v-text-field
                                        slot="activator"
                                        v-model="form.entryDateEnd"
                                        label="立项时间(截止)"
                                        :rules="rules.endDate"
                                        hint="格式YYYY-MM-DD, 如：2018-10-01"
                                        persistent-hint
                                />
                                <v-date-picker
                                        v-model="entryDateEnd"
                                        locale="zh-cn"
                                        @change="nv => form.entryDateEnd= nv"
                                />
                            </v-menu>
                        </v-flex>

                        <v-flex xs12 sm4>
                            <proj-tpe-tree v-model="form.types"/>
                            <!--
                            <v-autocomplete
                                    label="项目类型"
                                    clearable
                                    v-model="form.types"
                                    multiple
                                    chips
                                    small-chips
                                    deletable-chips
                                    item-text="name"
                                    item-value="dbid"
                                    :items="typeItems"
                                    hint="选择要检索的项目类型，可多选，支持关键词过滤。"
                                    persistent-hint
                                    :menu-props="{maxHeight:600}"
                            >
                                <template slot="item" slot-scope="data">
                                    <template v-if="typeof data.item !== 'object'">
                                        <v-list-tile-content v-text="data.item.name"/>
                                    </template>
                                    <template v-else>
                                        <v-list-tile-content>
                                            <v-list-tile-title class="pl-3" v-html="data.item.name"/>
                                        </v-list-tile-content>
                                    </template>
                                </template>
                            </v-autocomplete>
                            -->
                        </v-flex>

<!--                        <v-flex xs12 sm2>-->
<!--                            <v-autocomplete-->
<!--                                    label="项目类型属性"-->
<!--                                    clearable-->
<!--                                    v-model="form.typeCategory"-->
<!--                                    item-text="name"-->
<!--                                    item-value="name"-->
<!--                                    :items="typeCategoryItems">-->
<!--                            </v-autocomplete>-->
<!--                        </v-flex>-->

                      <v-flex xs12 sm2>
                        <v-menu
                            v-model="menuOpen"
                            :close-on-content-click="false"
                            :nudge-bottom="10"
                            offset-y
                            max-height="300"
                        >
                          <!-- 触发器：模拟输入框 -->
                          <template v-slot:activator="{ on }">
                            <v-text-field
                                v-on="on"
                                label="项目类型属性"
                                :value="displayText"
                                readonly
                                clearable
                                @click:clear="clearSelection"
                                hide-details
                            ></v-text-field>
                          </template>

                          <!-- 菜单内容：手动渲染选项 -->
                          <v-list dense>
                            <v-list-tile
                                v-for="item in typeCategoryItems"
                                :key="item.name"
                                @click.stop
                            >
                              <v-list-tile-action>
                                <v-checkbox
                                    :input-value="isSelected(item.name)"
                                    @change="toggleSelection(item.name)"
                                    color="primary"
                                ></v-checkbox>
                              </v-list-tile-action>
                              <v-list-tile-content>
                                <v-list-tile-title>{{ item.name }}</v-list-tile-title>
                              </v-list-tile-content>
                            </v-list-tile>
                          </v-list>
                        </v-menu>
                      </v-flex>

                        <v-flex xs12 sm2>
                            <v-autocomplete
                                    label="项目等级"
                                    clearable
                                    v-model="form.typeGrade"
                                    item-text="name"
                                    item-value="name"
                                    :items="typeGradeItems">
                            </v-autocomplete>
                        </v-flex>

                        <v-flex xs12 sm2>
                            <v-autocomplete
                                    label="项目状态"
                                    clearable
                                    v-model="form.projStatusId"
                                    item-text="name"
                                    item-value="dbid"
                                    :items="projStatusItems"
                                    :menu-props="{maxHeight:600}">
                            </v-autocomplete>
                        </v-flex>

                      <v-flex xs12 sm2>
                        <v-autocomplete
                            label="性质"
                            clearable
                            required
                            v-model="form.property"
                            :items="propertyItems"
                        />
                      </v-flex>

                        <v-flex xs12>
                            <span>审核状态：</span>
                            <v-btn-toggle
                                    v-model="form.statusId"
                                    class="transparent"
                                    style="background:none;box-shadow:none">
                                <v-btn value = "" flat > 全部 </v-btn>
                                <v-btn flat v-for="s in statusItems" :key="s.dbid" :value="s.identifier">{{s.name}}
                                </v-btn>
                            </v-btn-toggle>
                        </v-flex>

                    </v-layout>
                </v-flex>
                <v-flex d-flex xs2 text-xs-center>
                    <div>
                        <v-btn color="primary" @click="onSearch">
                            <v-icon dark>search</v-icon>
                            检索
                        </v-btn>
                    </div>
                </v-flex>
            </v-layout>
        </v-container>

        <v-divider/>

        <v-data-table
                :headers="headers"
                :loading="loading"
                item-key="dbid"
                :pagination.sync="query"
                :items="pageResult.items"
                :total-items="pageResult.total"
                :rows-per-page-items="[10, 25, 50, 100, 200]">
            <template slot="items" slot-scope="props">
                <td>
                    {{ props.index + 1}}
                </td>
                <td><span style="font-weight: bold"
                          :class="`${props.item.projStatus.color || ''}--text`">{{ props.item.name }}</span>
                    <br/>
                    [{{ props.item.projStatus? props.item.projStatus.name: '空' }}] {{ props.item.code }}, {{
                    props.item.number }}
                </td>
                <td>
                    <span style="font-weight: bold">{{props.item.type? props.item.type.name: ''}}</span>
                    <br/>
                    {{props.item.client}}
                </td>
                <td>
                    <span style="font-weight: bold">{{ props.item.department? props.item.department.name: '' }}</span>
                    <br/>
                    {{ `${props.item.leaderName} ${props.item.leaderPhone || ''}` }}
                </td>
                <td>
                    <span style="font-weight: bold">{{ `${props.item.startDate }~${props.item.finishDate}` }}</span>
                    <br/>
                    合同: {{ props.item.contractAmounts | currency}}元
                    <br/>
                    实到: {{ (props.item.income || 0) | currency}}元
                </td>
                <!--<td>-->
                <!--<span style="font-weight: bold">{{ props.item.entryDate }}</span>-->
                <!--<br/>-->
                <!--{{ props.item.status.name }}-->
                <!--</td>-->

                <td>
                    <span style="font-weight: bold">{{ props.item.entryDate }}</span>
                    <br/>
                    <v-tooltip top>
                        <v-chip small class="mx-0" slot="activator"
                                :color="props.item.status.color"
                                @click="() => { history=props.item.history; hist = true; }">
                            {{ props.item.status.name }}
                        </v-chip>
                        <span>点击查看审核历史</span>
                    </v-tooltip>
                </td>
                <td class="justify-center layout px-0">
                    <!-- v-if="props.item.projStatusId != 'DqWTPeQRcAA'" -->
                    <v-tooltip top>
                        <v-btn icon class="mx-0" slot="activator"
                               @click="() => { viewDbid = props.item.dbid; view = true; }">
                            <v-icon color="teal">more_horiz</v-icon>
                        </v-btn>
                        <span>查看</span>
                    </v-tooltip>
                    <v-tooltip top>
                        <v-btn icon class="mx-0" slot="activator"
                               @click="() => { editDbid = props.item.dbid; edit = true; }"
                               :disabled="submitDisabled(props.item)">
                            <v-icon color="teal">edit</v-icon>
                        </v-btn>
                        <span>编辑</span>
                    </v-tooltip>
                    <v-tooltip top>
                        <v-btn icon class="mx-0" slot="activator"
                               @click="() => { rowIdx = props.index; submitDbid = props.item.dbid; submitMsg = props.item.name; submit = true; }"
                               :disabled="submitDisabled(props.item)">
                            <v-icon color="teal">publish</v-icon>
                        </v-btn>
                        <span>提交</span>
                    </v-tooltip>
                    <v-tooltip top>
                        <v-btn icon class="mx-0" slot="activator"
                               @click="() => { rowIdx = props.index; reviewDbid = props.item.dbid; reviewMsg = props.item.name; reviewActs = props.item.actions; review = true; }"
                               :disabled="reviewDisabled(props.item)">
                            <v-icon color="teal">playlist_add_check</v-icon>
                        </v-btn>
                        <span>审核</span>
                    </v-tooltip>
                    <v-tooltip top>
                        <v-btn icon class="mx-0" slot="activator"
                               @click="() => { $router.push(`/proj/manage/${props.item.dbid}`) }">
                            <v-icon color="teal">toc</v-icon>
                        </v-btn>
                        <span>管理/查看</span>
                    </v-tooltip>
                    <v-tooltip top>
                        <v-btn icon class="mx-0" slot="activator"
                               @click="() => { deleDbid = props.item.dbid; deleMsg = props.item.name; dele = true; }"
                               :disabled="submitDisabled(props.item)">
                            <v-icon color="pink">delete_forever</v-icon>
                        </v-btn>
                        <span>删除</span>
                    </v-tooltip>
                </td>
            </template>
        </v-data-table>

        <x-view
                v-model="view"
                :dbid="viewDbid"
        />

        <x-submit
                v-model="submit"
                :dbid="submitDbid"
                :message="submitMsg"
                :uri="uri"
                @ok="(it) => Object.assign(pageResult.items[rowIdx],it)"
        />

        <x-review
                v-model="review"
                :dbid="reviewDbid"
                :message="reviewMsg"
                :uri="uri"
                :actions="reviewActs"
                @ok="(it) => Object.assign(pageResult.items[rowIdx],it)"
        />

        <x-edit
                v-model="edit"
                :dbid="editDbid"
                v-on:ok="onEditOk"
        />

        <x-delete
                v-model="dele"
                :message="deleMsg"
                :uri="uri"
                :dbid="deleDbid"
                v-on:ok="onDeleOk"
        />

        <x-history
                v-model="hist"
                :history="history"
                :status="statusItems"
        />

    </v-card>
</template>

<script>
    import {mapGetters} from 'vuex'
    import mixin from '@/mixin'

    import XView from './View'
    import XEdit from './Edit'

    import ProjTpeTree from './widgets/ProjTpeTree'

    import XDelete from '@/components/global/Delete'
    import XReview from '@/components/global/Review'
    import XSubmit from '@/components/global/Submit'
    import XHistory from '@/components/global/History'

    const baseUri = '/api/proj/project';
    //执行StatusServlet，项目审核进程与code_status关联
    const statusUri = '/api/proj/status';
    const deptUri = '/api/syst/department';
    //ProjStatusServlet，从projStatus表获取项目状态
    const projStatusUri = '/api/proj/proj-status';
    const typeUri = '/api/proj/project-type/flatten/tree';
    const typeGradeUri = '/api/proj/type-grade';
    const typeCategoryUri = '/api/proj/type-category';

    export default {
        // 混入模块主页面（index）基本功能
        mixins: [mixin.index(baseUri)],
        components: {XView, XEdit, XSubmit, XReview, XDelete, XHistory, ProjTpeTree},

        data() {
            return {
                uri: baseUri,

                // 检索、分页、排序条件条件
                query: {
                    statusId: '',
                    name: '',
                    leaderName: '',
                    member: '',
                    entryDateStart: '',
                    entryDateEnd: '',
                    deptId: '',
                    client: '',
                    typeCategory: [],
                    typeGrade: '',
                    property: null,

                    page: 1,
                    rowsPerPage: 25,
                    sortBy: null,
                    descending: null,
                    totalItems: null
                },

                // 检索框
                form: {
                    statusId: '',
                    name: '',
                    leaderName: '',
                    member: '',
                    entryDateStart: '',
                    entryDateEnd: '',
                    deptId: '',
                    client: '',
                    typeCategory: [],
                    typeGrade: '',
                    types: [],
                    property: null,
                },

                tempStatusId : '',
                statusItems: [],
                deptItems: [],
                typeItems: [],
                projStatusItems: [],

                typeGradeItems: [],
                typeCategoryItems: [],

                menuEntryDateStart: false,
                entryDateStart: null,

                menuEntryDateEnd: false,
                entryDateEnd: null,

                // 表头
                headers: [
                    {text: '#', align: 'left', sortable: false, value: 'dbid', width: "20"},
                    {text: '项目名称 / 编号，批准号', align: 'left', sortable: true, value: 'name'},
                    {text: '项目类别 / 委托单位', align: 'left', sortable: true, value: 'type', width: "220"},
                    {text: '承担单位 / 负责人, 电话', align: 'left', sortable: true, value: 'department', width: "220"},
                    {text: '起止时间 / 合同金额 / 实到金额', align: 'left', sortable: true, value: 'startDate', width: "200"},
                    {text: '立项时间 / 审核状态', align: 'left', sortable: true, value: 'statusId'},
                    {text: '操作', align: 'center', sortable: false, value: 'dbid', width: "60"}
                ],

                manage: false,
                manageDbid: null,

                menuOpen: false,
               // 选中的值（字符串数组）
                selectedValues: [], // ← 这就是你最终要提交的数据

                rowIdx: null,

                view: false,
                viewDbid: null,

                submit: false,
                submitDbid: null,
                submitMsg: null,

                review: false,
                reviewDbid: null,
                reviewMsg: null,
                reviewActs: [],

                edit: false,
                editDbid: null,

                dele: false,
                deleDbid: null,
                deleMsg: null,

                hist: false,
                history: [],

                propertyItems: [{value: 'zk', text: '自科'}, {value: 'sk', text: '社科'}],

                rules: {

                    startDate: [
                        v => window.xutil.regexpDate().test(v) || '日期格式错误'
                    ],
                    endDate: [
                        v => (v && window.xutil.regexpDate().test(v)) || '日期格式错误',
                        v => (v && v > this.form.entryDateStart) || "截止日期必须晚于起始日期。"
                    ]
                }
            }
        },

        created() {
            // 加载审核状态
            this.axios.all([
                this.axios.get(statusUri, {params: {sort: 'rank.asc'}}),
                this.axios.get(deptUri, {params: {limit: 65535, disabled: 'F', sort: 'rank.asc'}}),
                this.axios.get(typeUri),
                this.axios.get(projStatusUri),
                this.axios.get(typeGradeUri),
                this.axios.get(typeCategoryUri)
            ]).then(
                this.axios.spread(
                    (rspStaus, rspDept, rspType, rspProjStatus, rspTypeGrade, rspTypeCategory) => {
                        this.statusItems = rspStaus.data;
                        this.deptItems = rspDept.data.items;
                        this.projStatusItems = rspProjStatus.data.items;

                        this.typeGradeItems = rspTypeGrade.data;
                        this.typeCategoryItems = rspTypeCategory.data;

                        //rspType.data.forEach(v => v.disabled = !v.leaf);
                        this.typeItems = rspType.data.reduce(
                            (acc, v, i) => {
                                if (!v.leaf) {
                                    if (i > 0)
                                        acc.push({divider: true}, {header: v.name});
                                    else
                                        acc.push({header: v.name});
                                } else {
                                    acc.push(v);
                                }
                                return acc;
                            }, []);
                    }
                )
            )
        },

        computed: {
            ...mapGetters(['funcIds']),
            excelUrl() {
                // window.console.log(this.form);
                const url = '/api/proj/project/exp/fmt/excel';
                return window.xutil.buildUrl(url, Object.assign({limit: 2000}, this.form))
            },
          displayText() {
            return this.selectedValues.join(', ');
          }
        },

        methods: {

            // 检索响应函数
            onSearch() {
                //此段代码解决状态为全部但不显示数据的问题
                if (this.form.statusId === 0) {
                  this.form.statusId = ''
                }
                Object.assign(this.query, this.form);
                this.query.page = 1;
                window.console.log("this.query")
                window.console.log(this.query)
                this.doRoute(this.query);
            },

            submitDisabled(item) {
                return !(
                    // 当前用户拥有提交功能
                    (this.funcIds.includes('c_proj_project') || this.funcIds.includes('u_proj_project'))
                    // 并且，当前记录需要提交
                    && item.actions.find(a => a.action === 'submit'))
            },
            reviewDisabled(item) {
                return !(
                    // 当前用户拥有审核功能
                    this.funcIds.includes('u_proj_project')
                    // 并且，当前记录需要审核
                    && item.actions.find(a => ['approve', 'return', 'revoke'].includes(a.action)))
            },
            deleteDisabled(item) {
                return !(
                    // 当前用户拥有审核功能
                    this.funcIds.includes('d_proj_project')
                    // 并且，当前记录需要审核
                    && item.actions.find(a => ['submit'].includes(a.action)))
            },
          isSelected(name) {
            return this.selectedValues.includes(name);
          },
          toggleSelection(name) {
            const index = this.selectedValues.indexOf(name);
            if (index >= 0) {
              this.selectedValues.splice(index, 1);
            } else {
              this.selectedValues.push(name);
            }
          },
          clearSelection() {
            this.selectedValues = [];
          }
        },

        watch: {
          selectedValues: {
            handler(newVal) {
              this.form.typeCategory = newVal; // 假设 form 在父级或当前 data 中
            },
            deep: true
          }
        }
    }
</script>
